import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cancel-btn',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './cancel-btn.component.html',
  styleUrl: './cancel-btn.component.scss',
})
export class CancelBtn {
  @Input() label: string = 'front.cancel-btn.cancel';
  @Input() disabled = false;
}
